
import Share from '../lib/share'

function init() {
  [...document.querySelectorAll("[data-share]")].map((item) => new Share(item).run());
}

document.addEventListener("DOMContentLoaded", init);
